var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: _vm.idName } },
    [
      _vm.workOrders.length
        ? _c("div", { staticClass: "fuel-utilization-wo__section-header" }, [
            _vm._v(_vm._s(_vm.status))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.workOrders, function(workOrder) {
        return _c("WorkOrderSummary", {
          key: workOrder.work_order_id,
          staticClass: "fuel-utilization-wo__summary",
          attrs: { "work-order": workOrder }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }